// 로그인 화면의 「저장」 — 아이디만 기억한다(H-04 · I-014).
// 예전에는 「패스워드 저장」이 Keycloak 비밀번호를 JSON 평문으로 localStorage 에 남겨, XSS 한 번이나 공유 PC 로 계정이 넘어갔다.
// 지금은 아이디만 남기고, 이미 저장된 옛 형식(password 포함)은 읽는 순간 아이디만 남기고 다시 쓴다.

/** 저장소 키 — 옛 키를 그대로 쓴다(옛 값을 만나면 비밀번호를 지우기 위해서) */
export const SAVED_LOGIN_KEY = 'poc_portal_auto_login';

type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** 저장된 아이디 — 없으면 null. 옛 형식(비밀번호 포함)이면 비밀번호를 지운 값으로 다시 쓴다 */
export function readSavedUsername(store: Store): string | null {
  try {
    const raw = store.getItem(SAVED_LOGIN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { username?: unknown; password?: unknown };
    const username = typeof parsed.username === 'string' && parsed.username ? parsed.username : null;
    if (parsed.password !== undefined || !username) {
      if (username) store.setItem(SAVED_LOGIN_KEY, JSON.stringify({ username }));
      else store.removeItem(SAVED_LOGIN_KEY);
    }
    return username;
  } catch {
    try { store.removeItem(SAVED_LOGIN_KEY); } catch { /* 저장소를 못 쓰는 환경 — 저장하지 않으면 그만이다 */ }
    return null;
  }
}

/** 로그인 성공 뒤 — remember 이면 아이디만 저장, 아니면 지운다. 비밀번호는 어떤 경우에도 받지 않는다 */
export function rememberUsername(store: Store, username: string, remember: boolean): void {
  try {
    if (remember && username) store.setItem(SAVED_LOGIN_KEY, JSON.stringify({ username }));
    else store.removeItem(SAVED_LOGIN_KEY);
  } catch {
    // 저장소를 못 쓰는 환경 — 저장하지 않는다
  }
}
